module.exports = __webpack_public_path__ + "img/w3_link_white.9ba20322.png";